<template>
  <div class="free-video">
    <div class="content-box">
      <div class="demo" v-for="(item, index) in videoList" :key="index" @click="toLink(item.url,item.lessonName)">
        <img :src="item.img" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["videoList","pageName"],
  data() {
    return {};
  },
  methods: {
    toLink(url,name) {
       this.mai(this.pageName,name,1,null)
      window.open(url);
    }
  }
};
</script>

<style lang="less" scoped>
.free-video {
  .content-box {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 32px;
    margin-bottom: 8px;
    .demo {
      margin: 0px 13px;
      margin-bottom: 26px;
      width: 330px;
      height: 200px;
      border-radius: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>